export function isUnspecified(value: string) {
  return (value || "").toLocaleLowerCase() === "unspecified";
}
